module.exports = __webpack_public_path__ + "media/item-obtain.7e650108.ogg";